type FinalResponseAction = { status?: string | null; confirmationMessage?: string | null };

/**
 * Whether a final-response turn ended returning an action still awaiting the user's confirmation
 * (e.g. rename-page's "Confirm / Cancel"), as opposed to one that resolved. Shared by the send and
 * confirmed-tools flows so both classify the agent-run's `needs-input` vs `done` identically.
 */
export const isFinalResponseAwaitingConfirmation = (
	actions: ReadonlyArray<FinalResponseAction | null | undefined> | null | undefined,
): boolean =>
	Array.isArray(actions) &&
	actions.some(
		(action) =>
			action?.status === 'planned' ||
			(!!action?.confirmationMessage &&
				action?.status !== 'started' &&
				action?.status !== 'finished' &&
				action?.status !== 'cancelled' &&
				action?.status !== 'errored'),
	);
